export default __webpack_public_path__ + "8a01be4288fce3055843424e1b50f2e6.png";